const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');
const ShortText = require('./ShortText');
const DropDown = require('./DropDown');

module.exports = class EditableList extends Builder {
    constructor(title, properties) {
        super('formElement_EditableList', title, properties);
        if (!properties.propertyName) {
            throw new Error(
                `${title} does not have a 'propertyName'.  You must pass a 'propertyName' value in properties when creating formElements.`
            );
        }
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText, 'editableListElements');
        return shortText;
    }
    dropDown(title, properties) {
        let dropDown = new DropDown(title, properties);
        this.addChildBlock(dropDown, 'editableListElements');
        return dropDown;
    }
    editableList(title, properties) {
        let editableList = new EditableList(title, properties);
        this.addChildBlock(editableList, 'editableListElements');
        return editableList;
    }
};
